import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Apollo} from "apollo-angular";
import {
  create_new_external_web_link
} from "../../graphql/createCompanyEvent";
import {ActivatedRoute,} from "@angular/router";
import {
  delete_web_address,
  update_company_event_external_link
} from "../../graphql/updateCompanyEvent";
import {AlertService} from "../../../alert/alert.service";


@Component({
    selector: 'company-events-links',
    templateUrl: './company-events-links.component.html',
    styleUrls: ['./company-events-links.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompanyEventsLinksComponent implements OnInit{

  isEditMode:boolean;
  @Input() webAddresses:any[];
  @Input() y_drive:any;
  @Input() companyEventDrive:any;
  @Input() userCanEdit:any;
  public filesLinks:any = [];
  companyEventId:string | null
  isEditingLink:boolean = false;
  selectedLink:any;
  linkForm: FormGroup = new FormGroup<any>({
    link: new FormControl(null,),
    label: new FormControl(null)
  })

  constructor(private apollo: Apollo, private route: ActivatedRoute, public alertService: AlertService) {
  }

  ngOnInit() {
    this.companyEventId = this.route.snapshot.paramMap.get('id')
    this.extractAddressKeys(this.webAddresses)
  }

  extractAddressKeys(webAddresses:any){
    for(let i=0; i < webAddresses.length; i++){
      let hyperlink = this.responseToUrl(webAddresses[i].webAddress)
      let addrObj = {
        id: webAddresses[i].id,
        web_id: webAddresses[i].webAddress.id,
        path: hyperlink,
        name: webAddresses[i].name
      }
      this.filesLinks.push(addrObj)
    }

  }

  addExternalLink(){

      let url = this.stringToUrlRequest(this.linkForm.controls['link'].value)
      let query = this.isEditingLink ? update_company_event_external_link : create_new_external_web_link

      let createVar = {
        protocol: url.protocol,
        subdomain: url.subdomain,
        domain: url.domain,
        tld: url.tld,
        path: url.path,
        parameters: url.parameters,
        companyEventWebAddress: {create: {company_event_id: this.companyEventId, name: this.linkForm.controls['label'].value}}
      }



      let updateVar = {
        id: this.selectedLink?.web_id,
        protocol: url.protocol,
        subdomain: url.subdomain,
        domain: url.domain,
        tld: url.tld,
        path: url.path,
        parameters: url.parameters,
        companyEventWebAddress: {update: {id:this.selectedLink?.id, name: this.linkForm.controls['label'].value}}
      }

      this.apollo.mutate({
        mutation: query,
        variables: this.isEditingLink ? updateVar : createVar
      }).subscribe(({data}: any) => {
        let createResponse = data.createWebAddress;
        let updateResponse = data.updateWebAddress;
        if(createResponse!==undefined && createResponse!==null){
          let addrObj = {
            id: createResponse.companyEventWebAddress.id,
            web_id: createResponse.id,
            path: this.responseToUrl(createResponse),
            name: createResponse.companyEventWebAddress.name
          }
          this.linkForm.reset()
          this.filesLinks.push(addrObj)
        }
        if(updateResponse!==undefined && updateResponse!==null){
          const updateWeblinks = this.filesLinks.map((link:any) => {
            if(link.web_id == updateResponse.id){
              return {name: updateResponse.companyEventWebAddress.name, path: this.responseToUrl(updateResponse),web_id: updateResponse.id }
            }
            return link;
          })
          this.filesLinks = updateWeblinks;
          this.linkForm.reset()
        }
        this.isEditingLink = false;
        this.selectedLink = null;

      })

  }

  responseToUrl(parsedLink:any){
    let protocol = parsedLink.protocol
    let subdomain = parsedLink.subdomain
    let domain = parsedLink.domain
    let tld = parsedLink.tld
    let path = parsedLink.path
    let parameters = parsedLink.parameters
    let resolveUrl:string;
    resolveUrl = protocol==1 ? 'https' : 'http';
    resolveUrl += "://";
    resolveUrl += subdomain ? subdomain + "." : "";
    resolveUrl += domain ? domain + "." : "";
    resolveUrl += tld ? tld : "";
    resolveUrl += path ? path : "";
    resolveUrl += parameters ? parameters : "";
    return resolveUrl
  }

  stringToUrlRequest(urlString:string){
    const urlRegex = /^(?:(?:https?|ftp):\/\/)?(?:www\.)?[a-z0-9-]+(?:\.[a-z0-9-]+)+[^\s]*$/i;
    let isValidUrl = urlRegex.test(urlString)
    if(!isValidUrl){
      this.alertService.add("", "Invalid Url submission")
      return;
    }

    let responseObj:any = {
      protocol: 0,
      subdomain: null,
      domain: null,
      tld: null,
      path: null,
      parameters: null
    }

    if(!urlString.includes("http://") && !urlString.includes("https://")){
      urlString = "https://" + urlString
    }

    let urlParse = new URL(urlString)
    responseObj.protocol = urlParse.protocol == "https:" ? 1 : 0
    responseObj.path = urlParse.pathname;
    responseObj.parameters = urlParse.search
    let hostArr = urlParse.host.split(".")
    responseObj.subdomain = hostArr.length > 2 ? hostArr[0] : null;
    responseObj.tld = hostArr[hostArr.length-1]
    let domainArr = hostArr.length > 2 ? hostArr.slice(1,-1) : [hostArr[0]]
    responseObj.domain = domainArr.length > 1 ? domainArr.join(".") : domainArr[0];
    return responseObj;

  }


  deleteWebLink(data:any){
    let query = delete_web_address
    let rowId = data.web_id;
    this.apollo.mutate({
      mutation: query,
      variables: {
        id: rowId
      }
    }).subscribe(({data}: any) => {
      this.filesLinks = this.filesLinks.filter((adr:any) => adr.web_id!==data.deleteWebAddress.id);
    })
  }

  editToggle(){
    this.isEditMode = !this.isEditMode;
    this.isEditingLink = false;
    this.selectedLink = null;
    this.linkForm.reset();
  }

  editWeblink(link:any){
    this.isEditingLink = !this.isEditingLink;
    if(this.isEditingLink){
      this.selectedLink = link
      this.linkForm.controls['link'].setValue(link.path);
      this.linkForm.controls['label'].setValue(link.name);
    } else {
      this.selectedLink = null
      this.linkForm.reset()
    }

  }

}
